import { render, staticRenderFns } from "./stock_history.vue?vue&type=template&id=b47378fa&scoped=true"
import script from "./stock_history.vue?vue&type=script&lang=js"
export * from "./stock_history.vue?vue&type=script&lang=js"
import style0 from "./stock_history.vue?vue&type=style&index=0&id=b47378fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47378fa",
  null
  
)

export default component.exports